import React from "react";
import { AuthProvider } from "../contexts/AuthContext";
import { NotificationProvider } from "./NotificationContext";

export default function ContextProviders({
  children,
}: React.PropsWithChildren<{}>) {
  return (
    <AuthProvider>
      <NotificationProvider>
        {children}
      </NotificationProvider>
    </AuthProvider>
  );
}
